import axios_general from 'axios'
import { BASE_URL } from '@/urls.js'
import axios from '../../axios/index.js'

export default {
  getPeriodList() {
    return axios.get('periods/list')
  },
  invoiceList(data) {
    return axios.post('/invoices/list', data)
  },
  InvoiceDetails(id) {
    return axios.post('invoiceDetails', { id })
  },
  updateQBInvoice(invoice_id, QBInvoice) {
    return axios.post('invoices/updateQBinvoice', { invoice_id, QBInvoice })
  },
  updatePeriodExchangeRate(period_id, ExchangeRate) {
    return axios.post('updatePeriodExchangeRate', { period_id, ExchangeRate })
  },
  getCurrentPeriod() {
    return axios.get('getCurrentPeriod')
  },
  regenerateInvoice(InvoiceId) {
    return axios.post('regenerateInvoice', { InvoiceId })
  },
  resendEmailInvoice(InvoiceId) {
    return axios.post('resendEmailInvoice', { InvoiceId })
  },
  expenseListToLink(data) {
    return axios.get('expenseToLink', { params: data })
  },
  linkExpensesToInvoice(data) {
    return axios.post('linkExpensesToInvoice', data)
  },
  expensesAndPayrollList(data) {
    return axios.get('expenses_and_payroll', { params: data })
  },
  addComplementaryPayroll(data) {
    return axios.post('addComplementaryPayroll', data)
  },
  payrollListToLink(data) {
    return axios.get('payrollToLink', { params: data })
  },
  linkPayrollsToInvoice(data) {
    return axios.post('linkPayrollsToInvoice', data)
  },
  generateExclusiveExpenseReport(data) {
    return axios.post('generateExclusiveExpenseReport', data)
  },
  getCountInvoicesToSend(data) {
    return axios.get('getCountInvoice', { params: data })
  },
  sendPendingShelterFees(data){
    return axios_general.get(BASE_URL+'sendInvoiceShelterFee', { params: data })
  },
  generateReport(data){
    return axios.post('contralor/generate_report',data)
  },
  storeExtraFiles(data){
    return axios.post('contralor/extra_files',data,{
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  },
  getExpensesNextCashRequest(data) {
    return axios.get('invoices/getExpensesNextCashRequest', { params: data })
  },
  createShelterFeeManual(payload){
    return axios.post('shelter-fee/manual',payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
      processData: false,
      contentType: false
    })
  }

}
